import { render, staticRenderFns } from "./UserDepositDetail.vue?vue&type=template&id=812611d2"
import script from "./UserDepositDetail.vue?vue&type=script&lang=js"
export * from "./UserDepositDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports